import logo from "../assets/images/logo.svg"

const Logo = () => {
    return (
        <img src={logo} alt="jobify" className="logo" />
    )
}

export default Logo